import React, { useState, useEffect, useCallback, useContext } from "react";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";
import {
  Box,
  Card,
  Container,
  Typography,
  Button,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import update from "immutability-helper";
import Countdown from "react-countdown";
import { useNavigate } from "react-router-dom";

//import teamInfoStyle from "./TeamInfo.module.scss";
//import commonStyles from "../../../styles/common.module.scss";
import AlertDialog from "../../../components/AlertDialog.js";
import leagueLogo from "../../../assets/Premier_League-Logo.png";
import imgRes from "../../../assets/positionImgs/res.png";
import footField from "../../../assets/positionImgs/football_field.png";
import { Selection } from "./Selection";
//import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import { POSITIONS_DATA } from "../../../store/data/DummyData";
// import { PLAYERS } from "../../../store/data/DummyData";
import { project_url, admin_url } from "../../../store/data/Constants";

import { REFRESH_TOKEN_MUTATION } from "../../../graphQL/user_qry";
import { ItemTypes } from "../../../store/data/ItemTypes";
import { GET_LEAGUE_FORMATIONS_QUERY } from "../../../graphQL/formationToLeague_qry";
import styled from "styled-components";
import KeyboardReturn from "@mui/icons-material/KeyboardBackspace";
import Tooltip from "@material-ui/core/Tooltip";

var findAnd = require("find-and");
const mainPath = "/lms/media/";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    paddingLeft: 33,
    paddingTop: 23,
    paddingRight: 25,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    minHeight: 100,
    borderRadius: 8,
  },
  autoComStyle: {
    "& label.Mui-focused": {
      color: "#643d74",
    },
    "& .MuiFormControl-root": {
      width: "60%",
      height: 48,
      marginBottom: 5,
      "& .MuiInputLabel-outlined": {
        fontSize: 16,
      },
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#643d74",
      },
      borderRadius: 8,
      height: 48,
      fontSize: 16,
    },
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 8,
    width: "100px",
    padding: 0,
    height: "48px",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#765285",
    },
    "&:hover": {
      backgroundColor: "#765285",
    },
  },
}));
const FIXTUREOBJTEAMS_QUERY = `query fixtureObjectTeams($fixtureId:Int!){
  fixtureObjectTeams(fixtureId:$fixtureId){
    fixtureTeamId
    fixtureId{
      fixtureId
      lock
      fixtureWeek{
        scheduledDate
      }
      scheduledWeek{
        scheduledDate
      }
    }
    sleagueTeamId{
      sleagueTeamId
      teamId{
        name
        shortName
        logo
      }
    }
    scoreFinal
    home
    coachSeq
  }
}`;

const UPDATE_FIXTURE_TEAM = `
mutation updateFixtureTeam($fixtureTeamId: Int!, $coachSeq: String!) {
  updateFixtureTeam(
    fixtureTeamId: $fixtureTeamId,
    coachSeq: $coachSeq,
  ) {
    fixtureTeam{
      fixtureTeamId
      coachSeq
    }
  }
}
`;
const StyledTooltip = styled((props) => (
  <Tooltip classes={{ popper: props.className }} {...props} />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border: 1px solid #000;
    border-radius: 6px;
    font-size: 14px;
  }
`;
const TeamInfo = ({
  userFavTeam,
  fixtureTeamId,
  sleagueTeamId,
  fixtureId,
  leagueId,
  userSeqData,
  coachSeqVal,
  sleaguePlayers,
  sleagueTeamsData,
  passTeamSelectionsData,
  passSelectedFormation,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [players, setPlayers] = useState([]);
  const [formations, setFormations] = useState();
  const [selectedFormation, setSelectedFormation] = useState(() => {
    let coachVal = coachSeqVal.slice(0, 2).trim();
    if (coachVal) return coachVal;
    return "01";
  });
  const [fixDate, setFixDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [counterDate, setCounterDate] = useState("");
  const [competitor, setCompetitor] = useState([]);
  const [homeTeam, setHomeTeam] = useState([]);
  const [secondTeam, setSecondTeam] = useState([]);
  const [droppedPlayerNames, setDroppedPlayerNames] = useState([]);
  const [teamSelections, setTeamSelections] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [fixtureTeamsData] = useManualQuery(FIXTUREOBJTEAMS_QUERY);
  const [updateFixtureTeam] = useMutation(UPDATE_FIXTURE_TEAM);

  const formatter = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
  });

  const dayFormat = (day) => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    let format = "YYYYmonthDD";
    if (localStorage.getItem("preferedDateFormat")) {
      format = localStorage.getItem("preferedDateFormat");
    }
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "day").value +
        " " +
        dayFormat.find((a) => a.type == "month").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find((a) => a.type == "weekday").value +
        ", " +
        dayFormat.find((a) => a.type == "year").value +
        ", " +
        dayFormat.find((a) => a.type == "month").value +
        " " +
        dayFormat.find((a) => a.type == "day").value;
      return newFormat;
    }
  };

  const {
    loading: leagueFormationsDataLoading,
    error: leagueFormationsDataError,
    data: leagueFormationsData,
  } = useQuery(GET_LEAGUE_FORMATIONS_QUERY, {
    variables: {
      leagueId: leagueId,
    },
  });

  useEffect(() => {
    setPlayers(
      sleaguePlayers.map((player) => {
        let name = player.playerId.name;
        let onFieldName = player.playerId.onFieldName;
        let position = player.playerId.position;
        let jerseyNO = player.jerseyNO;
        let playerSeqNO = player.playerSeqNO;
        let type = ItemTypes.PLAYER;
        let status = player.status;
        let currentTeam = player.currentTeam;
        return {
          name,
          onFieldName,
          position,
          jerseyNO,
          playerSeqNO,
          type,
          status,
          currentTeam,
        };
      })
    );
  }, [sleaguePlayers]);
  useEffect(() => {
    let findPositionsData = POSITIONS_DATA.find((x) => {
      return x.formationSeqNo === selectedFormation;
    });
    if (!findPositionsData) return [];

    let resFound = [];
    let droppedPlayerNamesVal = [];
    let draftTeamSelections = findPositionsData.positionsData;
    let val = "";
    if (!coachSeqVal) return;
    ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"].map(
      (i) => {
        switch (i) {
          case "01":
            val = coachSeqVal.slice(4, 6);
            break;
          case "02":
            val = coachSeqVal.slice(8, 10);
            break;
          case "03":
            val = coachSeqVal.slice(12, 14);
            break;
          case "04":
            val = coachSeqVal.slice(16, 18);
            break;
          case "05":
            val = coachSeqVal.slice(20, 22);
            break;
          case "06":
            val = coachSeqVal.slice(24, 26);
            break;
          case "07":
            val = coachSeqVal.slice(28, 30);
            break;
          case "08":
            val = coachSeqVal.slice(32, 34);
            break;
          case "09":
            val = coachSeqVal.slice(36, 38);
            break;
          case "10":
            val = coachSeqVal.slice(40, 42);
            break;
          case "11":
            val = coachSeqVal.slice(44, 46);
        }

        resFound = findAnd.returnFound(players, {
          playerSeqNO: val ? val : null,
        });
        // for that case that found more than one player with this playerSeqNO(val)
        if (resFound && resFound.length > 1) {
          let resFoundTrueCurentTeam = findAnd.returnFound(resFound, {
            currentTeam: true,
          });
          resFound = resFoundTrueCurentTeam;
        }
        if (resFound) {
          draftTeamSelections = findAnd.changeProps(
            draftTeamSelections,
            { positionSeqNo: i },
            {
              lastDroppedItem: {
                name: resFound.name,
                onFieldName: resFound.onFieldName,
                playerSeqNO: resFound.playerSeqNO,
                jerseyNO: resFound.jerseyNO,
              },
            }
          );
          droppedPlayerNamesVal.push(resFound.name);
        }
      }
    );
    setDroppedPlayerNames(droppedPlayerNamesVal);
    setTeamSelections(draftTeamSelections);
    passTeamSelectionsData(droppedPlayerNamesVal, draftTeamSelections);
  }, [players]);

  useEffect(() => {
    const formationsList = [];
    const parentFormations = [];

    if (
      !leagueFormationsDataLoading &&
      leagueFormationsData &&
      leagueFormationsData.leagueFormation
    ) {
      leagueFormationsData.leagueFormation.map((leagueFrm) => {
        if (
          !parentFormations.includes(leagueFrm.formationId.formationPrimary)
        ) {
          parentFormations.push(leagueFrm.formationId.formationPrimary);
        }
      });

      parentFormations.map((formation, i) => {
        formationsList.push({ mainCategory: formation });
        let derivedFormations = leagueFormationsData.leagueFormation.filter(
          (frm) => {
            return frm.formationId.formationPrimary === formation;
          }
        );
        formationsList[i].derivedCategories = derivedFormations;
      });
    }
    setFormations(formationsList);
  }, [leagueFormationsData]);

  const renderSelectGroup = (formation) => {
    const items = formation.derivedCategories.map((f) => {
      return (
        <MenuItem
          style={{ paddingLeft: 30, fontSize: 14 }}
          divider={true}
          key={f.formationId.formationSeqNO}
          value={f.formationId.formationSeqNO}
        >
          {f.formationId.title}
        </MenuItem>
      );
    });
    return [
      <ListSubheader
        style={{
          color: "black",
          fontSize: 14,
          fontWeight: "bold",
          backgroundColor: "white",
          marginLeft: 0,
        }}
      >
        {formation.mainCategory}
      </ListSubheader>,
      items,
    ];
  };

  useEffect(() => {
    const loadImage = (image) => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image();
        loadImg.src = image;
        // wait 500 milliseconds to simulate loading time
        loadImg.onload = () =>
          setTimeout(() => {
            resolve(image);
          }, 200);
        loadImg.onerror = (err) => {
          reject(err);
        };
      });
    };
    let IMAGES = [];
    if (teamSelections) {
      if (teamSelections.GK) IMAGES.push(imgRes, teamSelections.GK[0].img);
      if (teamSelections.DEF && teamSelections.DEF.defLane_col_1)
        teamSelections.DEF.defLane_col_1.map((i) => IMAGES.push(i.img));
      if (teamSelections.DEF && teamSelections.DEF.defLane_col_2)
        teamSelections.DEF.defLane_col_2.map((i) => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_1)
        teamSelections.MID.midLane_col_1.map((i) => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_2)
        teamSelections.MID.midLane_col_2.map((i) => IMAGES.push(i.img));
      if (teamSelections.MID && teamSelections.MID.midLane_col_3)
        teamSelections.MID.midLane_col_3.map((i) => IMAGES.push(i.img));
      if (teamSelections.FOR && teamSelections.FOR.forLane_col_1)
        teamSelections.FOR.forLane_col_1.map((i) => IMAGES.push(i.img));
      if (teamSelections.FOR && teamSelections.FOR.forLane_col_2)
        teamSelections.FOR.forLane_col_2.map((i) => IMAGES.push(i.img));
    }
    if (IMAGES.length == 0) return;
    Promise.all(IMAGES.map((img) => loadImage(img)))
      .then(() => setIsLoad(true))
      .catch((err) => console.log("Failed to load images", err));
  }, [teamSelections]);

  useEffect(async () => {
    let { loading, error, data } = await fixtureTeamsData({
      variables: {
        fixtureId: fixtureId,
      },
    });
    // Set Coach Team Data
    if (!loading && data && data.fixtureObjectTeams) {
      data.fixtureObjectTeams.map((fixtureTeam) => {
        // Set Coach team data
        if (
          parseInt(fixtureTeam.sleagueTeamId.sleagueTeamId) === sleagueTeamId
        ) {
          if (fixtureTeam.home) {
            console.log("fixtureTeam.home__________", fixtureTeam);
            setHomeTeam([
              userFavTeam.teamInfo,
              fixtureTeam.scoreFinal !== null ? fixtureTeam.scoreFinal : "",
            ]);
          } else
            setSecondTeam([
              userFavTeam.teamInfo,
              fixtureTeam.scoreFinal !== null ? fixtureTeam.scoreFinal : "",
            ]);

          var options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            //second: "2-digit",
            hour12: true,
          };
          // convert to milliseconds
          setCounterDate(
            new Date(fixtureTeam.fixtureId.fixtureWeek.scheduledDate).getTime()
          );
          var fixDate = new Date(
            fixtureTeam.fixtureId.fixtureWeek.scheduledDate
          ).toLocaleTimeString("en-us", options);
          var year = fixDate.split(" ")[3];
          var day = fixDate.split(" ")[2];
          var month = fixDate.split(" ")[1];
          var time = fixDate.split(" ")[4];
          var pam = fixDate.split(" ")[5];
          var weekday = fixDate.split(" ")[0];
          var formatedDate =
            weekday +
            " " +
            day.split(",")[0] +
            " " +
            month +
            " " +
            year.split(",")[0];
          var formatedTime =
            fixDate.split(" ")[5] + " " + fixDate.split(" ")[6]; //time + " " + pam;
          setFixDate(
            dayFormat(fixtureTeam.fixtureId.fixtureWeek.scheduledDate)
          ); //formatedDate);
          setStartTime(formatedTime);
        }
        // Set Coach team competitor for that fixtureId
        else {
          if (fixtureTeam.home)
            setHomeTeam([
              fixtureTeam.sleagueTeamId.teamId,
              fixtureTeam.scoreFinal !== null ? fixtureTeam.scoreFinal : "",
            ]);
          setCompetitor([
            fixtureTeam.sleagueTeamId.teamId,
            fixtureTeam.scoreFinal !== null ? fixtureTeam.scoreFinal : "",
          ]);
        }
      });
    }
    if (error && error.graphQLErrors[0].message === "Signature has expired") {
      navigate(`/lms/${admin_url}/signin`);
    }
  }, [fixtureId, userFavTeam]);

  useEffect(() => {
    const findPositionsData = POSITIONS_DATA.find((x) => {
      return x.formationSeqNo === selectedFormation;
    });

    if (!findPositionsData) return;
    let resFound = [];
    let draftTeamSelections = findPositionsData.positionsData;

    // find position seq no from previous selected formation and put in new formation dropped item
    ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"].map(
      (item) => {
        resFound = findAnd.returnFound(teamSelections, {
          positionSeqNo: item,
        });

        if (resFound) {
          draftTeamSelections = findAnd.changeProps(
            draftTeamSelections,
            { positionSeqNo: item },
            { lastDroppedItem: resFound.lastDroppedItem }
          );
        }
      }
    );

    setTeamSelections(draftTeamSelections); //findPositionsData.positionsData);
    passTeamSelectionsData(droppedPlayerNames, draftTeamSelections);
  }, [selectedFormation]);

  const handleFormationChange = (event) => {
    setSelectedFormation(event.target.value);
    setIsLoad(false);
    passSelectedFormation(event.target.value);
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  const client = useContext(ClientContext);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`/lms/${admin_url}/signin`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate("/lms/signout");
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
    }
  };

  const handleDrop = useCallback(
    (index, item, pos, posLane) => {
      if (localStorage.getItem("refreshToken")) {
        onRefreshToken();
      } else navigate(`/lms/${admin_url}/signin`);
      let resFound = findAnd.returnFound(players, {
        playerSeqNO: item.playerSeqNO,
      });
      if (resFound && resFound.status !== "Fit" && resFound.status !== "Booked")
        return;
      let draftTeamSelections = [];
      const { name, playerSeqNO, onFieldName } = item;

      if (droppedPlayerNames.indexOf(name) > -1) return;
      // If a player is dropped into the position of another player, delete the previous player
      if (pos === "GK") {
        if (teamSelections[pos][index].lastDroppedItem) {
          var i = droppedPlayerNames.indexOf(
            teamSelections[pos][index].lastDroppedItem.name
          );
          i > -1 && droppedPlayerNames.splice(i, 1);
        }
        draftTeamSelections = update(teamSelections, {
          [pos]: {
            [index]: {
              lastDroppedItem: {
                $set: item,
              },
            },
          },
        });
      } else {
        if (teamSelections[pos][posLane][index].lastDroppedItem) {
          var i = droppedPlayerNames.indexOf(
            teamSelections[pos][posLane][index].lastDroppedItem.name
          );
          i > -1 && droppedPlayerNames.splice(i, 1);
        }
        draftTeamSelections = update(teamSelections, {
          [pos]: {
            [posLane]: {
              [index]: {
                lastDroppedItem: {
                  $set: item,
                },
              },
            },
          },
        });
      }
      let draftDroppedPlayerNames = update(
        droppedPlayerNames,
        name ? { $push: [name /*, playerSeqNO*/] } : { $push: [] }
      );
      setDroppedPlayerNames(draftDroppedPlayerNames);
      setTeamSelections(draftTeamSelections);
      passTeamSelectionsData(draftDroppedPlayerNames, draftTeamSelections);
    },
    [droppedPlayerNames, teamSelections]
  );

  const onRemoveDroppedItem = (item, pos, posLane) => {
    // remove player from droppedPlayerNames list
    var i = droppedPlayerNames.indexOf(item.name);
    i > -1 && droppedPlayerNames.splice(i, 1);

    // set lastDroppedItem to null for removed item
    let draftTeamSelections = [];
    if (pos === "GK") {
      if (
        teamSelections.GK[0] &&
        teamSelections.GK[0].lastDroppedItem.name === item.name
      ) {
        draftTeamSelections = update(teamSelections, {
          [pos]: {
            [0]: {
              lastDroppedItem: {
                $set: null,
              },
            },
          },
        });
        setTeamSelections(draftTeamSelections);
      }
    } else {
      teamSelections[pos][posLane] &&
        teamSelections[pos][posLane].map(({ lastDroppedItem }, index) => {
          if (lastDroppedItem && lastDroppedItem.name === item.name) {
            draftTeamSelections = update(teamSelections, {
              [pos]: {
                [posLane]: {
                  [index]: {
                    lastDroppedItem: {
                      $set: null,
                    },
                  },
                },
              },
            });
            setTeamSelections(draftTeamSelections);
          }
        });
    }
    // console.log("droppedPlayerNames----",droppedPlayerNames)
    // console.log("draftTeamSelections----",draftTeamSelections)
    passTeamSelectionsData(droppedPlayerNames, draftTeamSelections);
  };
  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    // if (completed) {
    //   // Render a complete state
    //   return <Completionist />;
    // } else {
    return (
      <Box style={{ display: "flex", flexDirection: "column" }}>
        <Box
          mt={0.5}
          style={{
            display: "flex",
            flexDirection: "row",
            width: 225,
            justifyContent: "space-between",
          }}
        >
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="subtitle1" style={{ lineHeight: 1.25 }}>
              {days.toString().length > 2 ? days : ("0" + days).slice(-2)}
              {" : "}
            </Typography>
            <Typography
              variant="h6"
              style={{ fontWeight: 700, paddingLeft: 2, color: "#4D4D4D" }}
            >
              Days
            </Typography>
          </Box>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="subtitle1" style={{ lineHeight: 1.25 }}>
              {("0" + hours).slice(-2)}
              {" : "}
            </Typography>
            <Typography
              variant="h6"
              style={{ fontWeight: 700, paddingLeft: 2, color: "#4D4D4D" }}
            >
              Hrs
            </Typography>
          </Box>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="subtitle1" style={{ lineHeight: 1.25 }}>
              {" "}
              {("0" + minutes).slice(-2)}
              {" : "}
            </Typography>
            <Typography
              variant="h6"
              style={{ fontWeight: 700, paddingLeft: 2, color: "#4D4D4D" }}
            >
              Mins
            </Typography>
          </Box>
          <Box style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="subtitle1" style={{ lineHeight: 1.25 }}>
              {("0" + seconds).slice(-2)}{" "}
            </Typography>
            <Typography
              variant="h6"
              style={{ fontWeight: 700, paddingLeft: 2, color: "#4D4D4D" }}
            >
              Secs
            </Typography>
          </Box>
        </Box>
        <Box mt={0.5}>
          <Typography
            variant="h6"
            style={{ fontWeight: 400, letterSpacing: 0.7, color: "#757575" }}
          >
            Time left to select your starting team
          </Typography>
        </Box>
      </Box>
    );
  };

  const submitHandler = async (e) => {
    // alert(fixtureTeamId);
    // alert(userSeqData);
    if (Object.keys(userSeqData).length === 0 || userSeqData.includes("[00]")) {
      alert("Please select all Positions and then click Submit");
      return;
    }
    let coachSeqStrVal = userSeqData.replace(/</g, "");
    coachSeqStrVal = coachSeqStrVal.replace(/>/g, "");
    coachSeqStrVal = coachSeqStrVal.replace(/\[/g, "");
    coachSeqStrVal = coachSeqStrVal.replace(/]/g, "");
    // alert(coachSeqStrVal);

    let { data, error } = await updateFixtureTeam({
      variables: {
        fixtureTeamId: fixtureTeamId,
        coachSeq: coachSeqStrVal,
      },
    });
    if (error) {
      console.log("Error", error, data);
      alert("There is an error");
    } else {
      console.log("Success");
      alert(
        `Coach Team Selection for ${userFavTeam.teamInfo.shortName} team has been added successfully.`
      );
      setTimeout(() => {
        navigate(`/lms/${admin_url}/fixture`);
      }, 1000);
    }
  };

  const clearHandler = async (e) => {
    let clearUsrSeq = userSeqData.slice(2, 4);
    let draftTeamSelections = teamSelections;
    ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"].map(
      (i) => {
        draftTeamSelections = findAnd.changeProps(
          draftTeamSelections,
          { positionSeqNo: i },
          { lastDroppedItem: null }
        );
        clearUsrSeq += i + "00";
      }
    );
    setTeamSelections(draftTeamSelections);
    setDroppedPlayerNames([]);
    await passTeamSelectionsData([], draftTeamSelections);

    let { data, error } = await updateFixtureTeam({
      variables: {
        fixtureTeamId: fixtureTeamId,
        coachSeq: clearUsrSeq,
      },
    });
    if (error) {
      console.log("Error", error, data);
      alert("There is an error");
    } else {
      console.log("Success");
      alert("Coach Team Selection has been cleared successfully.");
    }
  };

  return (
    <Card className={classes.cardContainer}>
      <Box
        style={{ display: "flex", flexDirection: "row", width: "95%" }}
        alignItems="center"
        flexGrow={1}
      >
        <Box>
          <StyledTooltip title="Return to Fixtures">
            <IconButton
              edge="start"
              color="primary"
              onClick={() => {
                navigate(`/lms/${admin_url}/fixture`);
              }}
              size="large"
            >
              <KeyboardReturn sx={{ color: "#662483" }} fontSize="inherit" />
            </IconButton>
          </StyledTooltip>
        </Box>
        <Box
          style={{ display: "flex", justifyContent: "center", width: "95%" }}
        >
          <Typography variant="body1">
            Coach Team: {userFavTeam.teamInfo.shortName}{" "}
          </Typography>
        </Box>
      </Box>

      <Box
        mt={1}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "94%",
        }}
      >
        <Box>
          <Box style={{ display: "flex", flexDirection: "row" }}>
            <Typography
              variant="h4"
              style={{ fontWeight: 700, color: "#757575" }}
            >
              Fixture Date:
            </Typography>
            <Typography
              variant="h4"
              style={{ fontWeight: 700, color: "#4D4D4D", paddingLeft: 5 }}
            >
              {fixDate}
            </Typography>
          </Box>
          <Box mt={0.5} style={{ display: "flex", flexDirection: "row" }}>
            <Typography
              variant="h4"
              style={{ fontWeight: 700, color: "#757575" }}
            >
              Start Time:
            </Typography>
            <Typography
              variant="h4"
              style={{ fontWeight: 700, color: "#4D4D4D", paddingLeft: 5 }}
            >
              {startTime}
            </Typography>
            <Typography
              variant="h6"
              style={{ color: "#4D4D4D", paddingLeft: 5, paddingTop: 2 }}
            >
              (Your local time)
            </Typography>
          </Box>
        </Box>
        <Box mb={0.5}>
          <img src={leagueLogo} alt="leagueLogo" height={39} width={88} />
        </Box>
      </Box>
      {!isLoad ? (
        <div
          style={{
            backgroundImage: `url(${footField})`,
            width: 580,
            height: 408,
          }}
        />
      ) : (
        <div
          style={{
            display: "flex",
            float: "left",
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <div
              style={{
                //  overflow: "hidden",
                clear: "both",
              }}
            >
              {teamSelections.GK &&
                teamSelections.GK.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) => handleDrop(index, item, "GK", null)}
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "GK", null)
                          }
                        />
                      </div>
                    );
                  }
                )}
            </div>
            {teamSelections.DEF && teamSelections.DEF.defLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.DEF.defLane_col_1.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "DEF", "defLane_col_1")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "DEF", "defLane_col_1")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.DEF && teamSelections.DEF.defLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.DEF.defLane_col_2.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "DEF", "defLane_col_2")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "DEF", "defLane_col_2")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_1.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "MID", "midLane_col_1")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "MID", "midLane_col_1")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_2.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "MID", "midLane_col_2")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "MID", "midLane_col_2")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.MID && teamSelections.MID.midLane_col_3 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.MID.midLane_col_3.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "MID", "midLane_col_3")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "MID", "midLane_col_3")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            {teamSelections.FOR && teamSelections.FOR.forLane_col_1 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.FOR &&
                  teamSelections.FOR.forLane_col_1.map(
                    (
                      { accepts, lastDroppedItem, text, img, height, width },
                      index
                    ) => {
                      return (
                        <div>
                          <Selection
                            key={index}
                            accept={accepts}
                            img={img}
                            height={height}
                            width={width}
                            text={text}
                            lastDroppedItem={lastDroppedItem}
                            onDrop={(item) =>
                              handleDrop(index, item, "FOR", "forLane_col_1")
                            }
                            onRemoveDroppedItem={(item) =>
                              onRemoveDroppedItem(item, "FOR", "forLane_col_1")
                            }
                          />
                        </div>
                      );
                    }
                  )}
              </div>
            )}
            {teamSelections.FOR && teamSelections.FOR.forLane_col_2 && (
              <div
                style={{
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                {teamSelections.FOR.forLane_col_2.map(
                  (
                    { accepts, lastDroppedItem, text, img, height, width },
                    index
                  ) => {
                    return (
                      <div>
                        <Selection
                          key={index}
                          accept={accepts}
                          img={img}
                          height={height}
                          width={width}
                          text={text}
                          lastDroppedItem={lastDroppedItem}
                          onDrop={(item) =>
                            handleDrop(index, item, "FOR", "forLane_col_2")
                          }
                          onRemoveDroppedItem={(item) =>
                            onRemoveDroppedItem(item, "FOR", "forLane_col_2")
                          }
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
            <div
              style={{
                height: 408,
                width: 29,
                backgroundImage: `url(${imgRes})`,
                //backgroundRepeat: "no-repeat",
                flexDirection: "column",
                //border: "1px solid white"
              }}
            />
          </div>
        </div>
      )}

      <Box>
        {counterDate && (
          <Countdown date={counterDate} renderer={countdownRenderer} />
        )}
      </Box>

      {homeTeam[0] && (secondTeam[0] || competitor[0]) && (
        <Box mt={2} style={{ display: "flex", flexDirection: "row" }}>
          <Box
            style={{
              width: 190,
              display: "flex",
              paddingTop: 5,
              justifyContent: "end",
            }}
          >
            <Typography variant="subtitle2" style={{ fontSize: 18 }}>
              {homeTeam[0] && secondTeam
                ? homeTeam[0].shortName
                : userFavTeam.teamInfo && userFavTeam.teamInfo.shortName}{" "}
            </Typography>
          </Box>
          <Box
            ml={1}
            mr={1}
            style={{
              width: 200,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <Box>
              <img
                src={
                  homeTeam[0] && secondTeam && homeTeam[0].logo
                    ? mainPath + homeTeam[0].logo
                    : userFavTeam.teamInfo && userFavTeam.teamInfo.logo
                    ? mainPath + userFavTeam.teamInfo.logo
                    : ""
                }
                //alt="teamLogo"
                height={48}
                width={48}
              />
            </Box>
            <Box
              ml={1}
              mr={1}
              style={{
                width: 94,
                height: 40,
                backgroundColor: "#E0E0E0",
                borderRadius: 8,
                display: "flex",
                justifyContent: "center",
                //  paddingTop: 5,
              }}
            >
              <Typography variant="subtitle2">
                {homeTeam[1] + " - "}
                {!secondTeam[0]
                  ? competitor[0] && competitor[1]
                  : secondTeam[0] && secondTeam[1]}
              </Typography>
            </Box>
            <Box>
              <img
                src={
                  !secondTeam[0]
                    ? competitor[0] && competitor[0].logo
                      ? mainPath + competitor[0].logo
                      : ""
                    : secondTeam[0] && mainPath + secondTeam[0].logo
                }
                //alt="teamLogo"
                height={48}
                width={48}
              />
            </Box>
          </Box>
          <Box
            style={{
              width: 190,
              display: "flex",
              paddingTop: 5,
              justifyContent: "start",
            }}
          >
            <Typography variant="subtitle2" style={{ fontSize: 18 }}>
              {!secondTeam[0]
                ? competitor[0] && competitor[0].shortName
                : secondTeam[0] && secondTeam[0].shortName}
            </Typography>
          </Box>
        </Box>
      )}
      <Box
        mt={4}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <div className={classes.autoComStyle}>
          <FormControl size="small" style={{ width: 200 }}>
            <InputLabel id="demo-simple-select-label">My Formation</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="My Formation"
              value={selectedFormation || ""}
              onChange={handleFormationChange}
              MenuProps={{
                sx: {
                  "&& .Mui-selected": {
                    backgroundColor: "#FBF3FF",
                  },
                },
                PaperProps: {
                  sx: { maxHeight: 200 },
                },
              }}
            >
              {formations?.map((p) => renderSelectGroup(p))}
            </Select>
          </FormControl>
        </div>
        <Box>
          <Button
            variant="text"
            // style={{ marginLeft: "100px" }}
            onClick={clearHandler}
            color="primary"
            className={classes.outlinedButtonStyle}
            style={{ marginRight: 5 }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonStyle}
            onClick={submitHandler}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default TeamInfo;
